module.exports = __webpack_public_path__ + "assets/arrow-left.4afb63ab.svg";